import { Container, Typography } from '@mui/material';
import { Box } from '@mui/system';

export const Footer = () => {
  return (
    <Box component="footer" sx={{ py: 3 }}>
      <Container>
        <Typography
          variant="caption"
          align="center"
          component="div"
          sx={{ color: 'text.disabled', fontSize: 12 }}
        >
          © {new Date().getFullYear()} BlueGrace Logistics LLC. All Rights Reserved
        </Typography>
      </Container>
    </Box>
  );
};
